import {
  Row,
  Col,
  Card,
  Table,
  Typography,
  notification,
  DatePicker,
  Input,
  Button,
  Radio
} from "antd";

import { SearchOutlined } from "@ant-design/icons";

import React, { useEffect, useState } from "react";
import { getAccounts } from "../api/booking.service";
import moment from "moment";

const { RangePicker } = DatePicker;

const { Title } = Typography;

// project table start
// Helper function to add search functionality
const getColumnSearchProps = (dataIndex, placeholder, renderField) => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        placeholder={`Search ${placeholder}`}
        value={selectedKeys[0]}
        onChange={(e) =>
          setSelectedKeys(e.target.value ? [e.target.value] : [])
        }
        onPressEnter={() => confirm()}
        style={{ width: 188, marginBottom: 8, display: "block" }}
      />
      <Button
        type="primary"
        onClick={() => confirm()}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: (filtered) => (
    <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
  ),
  onFilter: (value, record) => {
    const recordValue = renderField ? renderField(record) : record[dataIndex];
    return recordValue
      ? recordValue.toString().toLowerCase().includes(value.toLowerCase())
      : false;
  },
});

const project = [
  {
    title: "REFERENCE NO",
    dataIndex: "referenceNo",
    width: 100,
    ...getColumnSearchProps("referenceNo", "Reference No", (record) => record.referenceNo),
    render: (text, record) => (
      <div>
        {`${record.referenceNo}`}
      </div>
    ),
  },
  {
    title: "JOURNEY TYPE",
    dataIndex: "referenceNo",
    width: 150,
    ...getColumnSearchProps("referenceNo", "Journey Type"),
    render: (text, record) => {
      const prefix = record.referenceNo.substring(0, 4);
      let journeyType = '';
      
      switch(prefix) {
        case 'SPAT':
          journeyType = 'Airport Booking';
          break;
        case 'SPVR':
          journeyType = 'Vehicle Rental';
          break;
        case 'SPTP':
          journeyType = 'Tourism Package';
          break;
        default:
          journeyType = 'Unknown';
      }

      return <div>{journeyType}</div>;
    }
  },
  {
    title: "(PKR) AMOUNT",
    dataIndex: "amount",
    width: 100,
    sorter: (a, b) => a.amount - b.amount,
    render: (text, record) => (
      <div style={{ color: 'green', fontWeight: 'bold' }}>
        {record.amount}
      </div>
    ),
  },
];

function Accounts() {

  const DEFAULT_START_DATE = moment("1970-01-01"); // Adjust this as necessary

  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [dateRange, setDateRange] = useState([DEFAULT_START_DATE, moment()]);
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    const filtered = bookings.filter((item) => {
      const itemDate = moment(item.created_at);
      const isInDateRange = itemDate.isBetween(dateRange[0], dateRange[1], null, "[]"); // Inclusive range
      
      // Get journey type from reference number
      const prefix = item.referenceNo.substring(0, 4);
      let journeyType = '';
      switch(prefix) {
        case 'SPAT':
          journeyType = 'Airport Booking';
          break;
        case 'SPVR':
          journeyType = 'Vehicle Rental';
          break;
        case 'SPTP':
          journeyType = 'Tourism Package';
          break;
        default:
          journeyType = 'Unknown';
      }

      // Filter based on both date range and displayed journey type
      return isInDateRange && journeyType !== 'Unknown';
    });
    setFilteredData(filtered);
  }, [bookings, dateRange]);

  // Compute total amount
  const [totalAmount, setTotalAmount] = useState(0);

  useEffect(() => {
    setTotalAmount(filteredData.reduce((sum, record) => sum + record.amount, 0));
  }, [filteredData]);

  const fetchBookings = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await getAccounts();
      setBookings(data?.data || []);
      // notification.success({ message: 'Data refreshed' })
    } catch (err) {
      setError('Failed to fetch bookings.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookings();
  }, []);

  const onChange = (e) => console.log(`radio checked:${e.target.value}`);

  const onChangeFilter = (e) => {
    console.log(`radio checked:${e.target.value}`);

    const value = e.target.value;
    const filtered = bookings?.filter(booking => {
      const prefix = booking?.referenceNo?.substring(0, 4);
      
      switch(value) {
        case 'airport':
          return prefix === 'SPAT';
        case 'rental':
          return prefix === 'SPVR';
        case 'tourism':
          return prefix === 'SPTP';
        case 'all':
          return true;
        default:
          return false;
      }
    });
    setFilteredData(filtered);
  }

  return (
    <>
    <div className="ant-filtertabs mb-4">
        <div className="flex justify-end antd-pro-pages-dashboard-analysis-style-salesExtra items-center">
          <Radio.Group onChange={onChangeFilter} defaultValue="all">
            <Radio.Button value="all">ALL</Radio.Button>
            <Radio.Button value="airport">AIRPORT</Radio.Button>
            <Radio.Button value="rental">RENTAL</Radio.Button>
            <Radio.Button value="tourism">TOURISM</Radio.Button>
          </Radio.Group>
        </div>
      </div>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={`Accounts Table`}
              extra={
                <>
                  <RangePicker
                    defaultValue={[DEFAULT_START_DATE, moment()]}
                    value={dateRange}
                    onChange={(dates) =>
                      setDateRange(dates ? [dates[0].startOf("day"), dates[1].endOf("day")] : [])
                    }
                    style={{ marginBottom: 20 }}
                    format="DD MMMM YYYY"
                  />
                </>
              }
            >
              <div className="table-responsive">
                <div className="ml-6" style={{
                  color: 'green',
                  fontSize: 22,
                  fontWeight: 'bold'
                }}>
                Total: {totalAmount} PKR
                </div>
                <Table
                  columns={project}
                  dataSource={filteredData}
                  pagination={{
                    pageSize: 100
                  }}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Accounts;
